import React from "react";

const Support = () => {
  return (
    <div>
      <h1>Support</h1>
    </div>
  );
};

export default Support;
